import { TypeSystem } from "../../support/type-system.support";
import { OrderGiftChoiceDetail } from "./order-gift-choice-detail.model";

	/**
	 * @description
	 *  Modelo de una selección de regalo en un pedido, para frontend.
	 *
	 * @see gigot-backend/Services/OrderService.cs
	 */

export class OrderGiftChoice {

	public details: OrderGiftChoiceDetail[];
	public id: number;
	public maxItems: number;
	public promotionTitle: string;
	public remaining: number;

	/**
	 * @description
	 *	Construye una selección de regalo con una semántica vacía. Nótese que
	 *	no es lo mismo que construir una selección con valores por defecto.
	 *	Las reglas generales de construcción son:
	 *
	 *      - Campos 'array' se definen como [].
	 *      - Campos 'boolean' se definen como 'false'.
	 *      - Campos 'Date' se definen como 'undefined'.
	 *      - Campos 'enum' se definen como 'undefined'.
	 *      - Campos 'number' se definen como 'undefined'.
	 *      - Campos 'string' se definen como '' (cadena vacía).
	 *      - Campos 'object' se definen llamando a su propio método #empty().
	 *      - Campos de la superclase se definen al igual que campos 'object'.
	 *      - Campos genéricos se definen como 'undefined'.
	 *		- Campos recursivos se definen como 'undefined'.
	 *
	 * @returns
	 *	Un selección de regalo vacío.
	 */
	public static empty(): OrderGiftChoice {
		const orderGiftChoice: OrderGiftChoice = new OrderGiftChoice();
		orderGiftChoice.details = [];
		orderGiftChoice.id = undefined;
		orderGiftChoice.maxItems = undefined;
		orderGiftChoice.promotionTitle = "";
		orderGiftChoice.remaining = undefined;
		return orderGiftChoice;
	}

	/**
	 * @description
	 *  Método de reificación de un modelo compatible anémico. Esto permite
	 *  ejecutar lógica de negocios sobre el modelo generado, siendo que el
	 *  valor de sus propiedades se mantiene.
	 *
	 * @param anemicOrderGiftChoice
	 *  El modelo anémico a reificar.
	 *
	 * @returns
	 *  Devuelve un modelo de esta clase, cuyas propiedades fueron copiadas en
	 *  profundidad desde el modelo anémico.
	 */
	public static from(anemicOrderGiftChoice: OrderGiftChoice): OrderGiftChoice {
		if (!anemicOrderGiftChoice) return undefined;
		const orderGiftChoice: OrderGiftChoice = OrderGiftChoice.empty();
		orderGiftChoice.details = TypeSystem.orElse(anemicOrderGiftChoice.details, [])
			.map(detail => OrderGiftChoiceDetail.from(detail));
		orderGiftChoice.id = anemicOrderGiftChoice.id;
		orderGiftChoice.maxItems = anemicOrderGiftChoice.maxItems;
		orderGiftChoice.promotionTitle = anemicOrderGiftChoice.promotionTitle;
		orderGiftChoice.remaining = anemicOrderGiftChoice.remaining;
		return orderGiftChoice;
	}
}
